import { render, staticRenderFns } from "./PanelAccountSettingsPayments.vue?vue&type=template&id=08126de2&scoped=true&"
import script from "./PanelAccountSettingsPayments.vue?vue&type=script&lang=js&"
export * from "./PanelAccountSettingsPayments.vue?vue&type=script&lang=js&"
import style0 from "./PanelAccountSettingsPayments.vue?vue&type=style&index=0&id=08126de2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08126de2",
  null
  
)

export default component.exports